import constants from "./constants.json"
export default constants[
  process.env.GATSBY_ENV || process.env.NODE_ENV || "development"
]
